import styled from "styled-components";
import colors from "styles/colors";

const Container = styled.div`
  width: 100%;

  .text-editor {
    position: relative;
  }

  .text-editor .text-editor-button {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
  }

  .text-editor .ProseMirror:focus {
    outline: none;
  }

  .text-editor .ProseMirror {        
    min-height: 200px;
    max-height: 200px;
    overflow: scroll;
  }
  
  // .text-editor {
  //   width: 100%;
  // }
`;

export {
  Container
};
